function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid, Container, Message } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import { forgotPassword } from '../actions';
import ForgotPasswordForm from '../components/ForgotPasswordForm';

var ForgotPassword = function (_React$Component) {
  _inherits(ForgotPassword, _React$Component);

  function ForgotPassword(props) {
    _classCallCheck(this, ForgotPassword);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleSubmit = function (email) {
      var _this$props = _this.props,
          forgotPassword = _this$props.forgotPassword,
          productFamilyId = _this$props.productFamilyId;
      forgotPassword(email, productFamilyId).then(function (success) {
        return success === true ? _this.setState({
          resetPasswordRequested: true
        }) : false;
      });
    };

    _this.state = {
      resetPasswordRequested: false // authToken: getAuthToken()

    };
    return _this;
  }

  ForgotPassword.prototype.render = function render() {
    /* TODO: Error handling, once the API has been implemented */
    var _props = this.props,
        isFetching = _props.isFetching,
        error = _props.error;
    var resetPasswordRequested = this.state.resetPasswordRequested;
    return React.createElement('div', {
      className: 'page--multifaceted-bg-grey'
    }, React.createElement(Container, {
      className: 'page-container'
    }, React.createElement('div', {
      className: 'login-form'
    }, React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 6
    }, React.createElement('div', {
      className: 'callout'
    }, React.createElement('h2', null, 'Forgot Password'), React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 10
    }, error && React.createElement(Message, {
      warning: true,
      icon: 'warning',
      content: error
    }), !resetPasswordRequested ?
    /* $FlowFixMe */
    React.createElement(ForgotPasswordForm, {
      handleSubmit: this.handleSubmit,
      isFetching: isFetching,
      error: error
    }) : React.createElement('div', null, React.createElement('p', null, 'If that account exists and you haven\'t reached your forgotten password limit, we have sent you an email with instructions on how to reset your password. Please check your email inbox.'), React.createElement('p', null, React.createElement(NavLink, {
      to: '/login'
    }, 'Back to Login')))))))))));
  };

  return ForgotPassword;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.auth.user.isFetching,
    error: state.auth.error
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    forgotPassword: forgotPassword
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);